import React, { useEffect, useState } from 'react'
import { useBenefits } from '../BenefitsProvider'
import { SelectField } from '~/components/shared/FormFields'
import { Button } from '~/lib/ui/button'
import { useTranslation } from '~/hooks/useTranslation'
import ResumeUpload from './ResumeUpload'
import { ServiceRequestForm } from './RequestForms'
import TabNav from '~/components/shared/TabNav/TabNav'
import { useIsMobile } from '~/hooks/useMediaQuery'
import TabButton from '~/components/shared/TabNav/TabButton'
import ButtonContainer from '~/components/shared/TabNav/ButtonContainer'
import { PanelContainer, TabPanel } from '~/components/shared/TabNav/index'
import { FormMessage } from '~/lib/ui/form'
import SavedStatusIcon from '~/components/shared/SavedStatusIcon'

const UploadNewResume = () => {
  const { t } = useTranslation('schedule_modal.resume_review')
  const {
    resumeReview,
    resumeId,
    uploadedResumeId,
    changeResume,
    submitted,
    select,
  } = useBenefits()

  const variant = select ? 'default' : 'coachcta'

  const noDocument = !(resumeId || uploadedResumeId)

  const [loading, setLoading] = useState(submitted)
  const handleUploadNewResumeClick = () => {
    setLoading(true)
    changeResume(resumeReview?.id)
  }

  return (
    <ServiceRequestForm>
      <FormTabNav t={t} />
      <div className="flex justify-center">
        <div>
          <Button
            type="button"
            onClick={handleUploadNewResumeClick}
            variant={variant}
            disabled={noDocument}
          >
            {t('submit_button')}
            <SavedStatusIcon
              loadingStatus={loading || submitted ? t('loading') : null}
            />
          </Button>
        </div>
      </div>
      <FormMessage />
    </ServiceRequestForm>
  )
}

export default UploadNewResume

const Wrapper = ({ children }) => {
  const isMobile = useIsMobile()
  if (isMobile) return children

  return (
    <div className="relative w-full overflow-x-scroll sm:static sm:overflow-auto">
      {children}
    </div>
  )
}

const FormTabNav = ({ t }) => {
  const { control, current_user, setUploadedResumeId, serviceRequestForm } =
    useBenefits()
  const userHasSystemResume = current_user.candidate_resumes?.length > 0
  const allowSystemResume = userHasSystemResume
  return (
    <TabNav defaultActiveTab={'upload_resume'}>
      {allowSystemResume && <TabNavButtons />}
      <PanelContainer asChild>
        <TabPanel name={'upload_resume'}>
          <UploadResume
            containerClassName="px-0 pb-0"
            resumeReview={true}
            setUploadedResumeId={setUploadedResumeId}
            serviceRequestForm={serviceRequestForm}
            className="min-h-[10rem] border-black"
            helpText={t('dropzone_help_text')}
          />
        </TabPanel>
        <TabPanel name="choose_resume">
          <SelectResume
            control={control}
            name="resume_document_id"
            label={t('select_resume_label')}
            choices={current_user.candidate_resumes}
            setUploadedResumeId={setUploadedResumeId}
          />
        </TabPanel>
      </PanelContainer>
    </TabNav>
  )
}

const UploadResume = ({ ...props }) => {
  const { setValue } = useBenefits()
  useEffect(() => {
    setValue('resume_document_id', null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <ResumeUpload {...props} />
}

const SelectResume = ({ setUploadedResumeId, ...props }) => {
  useEffect(() => {
    setUploadedResumeId(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <SelectField {...props} />
}
const TabNavButtons = () => {
  const isMobile = useIsMobile()
  const titleClass = isMobile ? '' : 'text-lg mx-0'

  const { t } = useTranslation('schedule_modal.resume_review')

  return (
    <Wrapper>
      <ButtonContainer
        carouselWrapperClass="min-h-[4.5rem] mb-8"
        className="mb-6 flex flex-row justify-between gap-5 min-[530px]:justify-start min-[530px]:gap-10"
        buttonClass="min-w-16"
        titleClass={titleClass}
      >
        <TabButton name={'upload_resume'} text={t('upload_resume')} />
        <TabButton name={'choose_resume'} text={t('choose_resume')} />
      </ButtonContainer>
    </Wrapper>
  )
}
